import { memo, useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import drawNewPlayers, { NewPlayersDatum } from "./drawNewPlayers";
import { PlayerDropsMessage } from "./PlayerDropsGenericSubcards";
import './timeline.css';


type NewPlayersChartProps = {
    data: NewPlayersDatum[];
    domain: [Date, Date];
    bucketMs: number;
    width: number;
    height: number;
    onHover: (datum: NewPlayersDatum | undefined) => void;
};

function NewPlayersChart({ data, domain, bucketMs, width, height, onHover }: NewPlayersChartProps) {
    const svgRef = useRef<SVGSVGElement>(null);
    const [renderError, setRenderError] = useState('');
    const [errorRetry, setErrorRetry] = useState(0);
    const margins = {
        top: 16,
        right: 16,
        bottom: 24,
        left: 40,
        axis: 4,
    };

    useEffect(() => {
        if (!svgRef.current || !width || !height) return;
        drawNewPlayers({
            svgRef: svgRef.current,
            setRenderError,
            size: { width, height },
            margins,
            domain,
            bucketMs,
            data,
            onHover,
        });
        setRenderError('');
    }, [data, domain, bucketMs, width, height, errorRetry]);

    return (
        <div className="size-full relative">
            <svg className="absolute inset-0 text-faint" ref={svgRef} width={width} height={height} />
            {renderError ? (
                <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-card/80">
                    <PlayerDropsMessage message={`Error rendering chart: ${renderError}`} />
                    <Button size="sm" variant="outline" onClick={() => setErrorRetry((c) => c + 1)}>
                        Retry
                    </Button>
                </div>
            ) : null}
        </div>
    );
}

export default memo(NewPlayersChart);
